import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import useMeta from "../hooks/useMeta";

const LanguageEnforcer = ({ children }) => {
  const location = useLocation();
  const { metaEvent } = useMeta();

  useEffect(() => {
    metaEvent("PageView");
  }, [location.pathname]);

  return children;
};

export default LanguageEnforcer;
